import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';
import { User, UserId } from '@/types/user';


export default {
  namespaced: true,
  state: {
    users: [] as User[],
    selectedUsers: [] as UserId[],
  },
  mutations: {
    set(state: any, payload: any) {
      state.users = payload;
    },
    setSelected(state: any, payload: UserId[]) {
      state.selectedUsers = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    resetUsers({ commit }: {commit: any}): void {
      commit('set', []);
    },
    updateUsers({ commit, state }: {commit: any, state: any}, { force }: { force: boolean }): void {
      if (state.users.length && !force ) { return; }
      request('get', `users` )
      .then((response: AxiosResponse) => {
        commit('set', response.data);
      });
    },
  },
  getters: {
    list: (state: any): User[] => state.users,
    selected: (state: any): UserId[] => state.selectedUsers,
  },
};

